export default "__VITE_ASSET__dbbefb87__"